import React, { PropTypes } from 'react'
import Panel from 'react-bootstrap/lib/Panel'

import DefaultProfile from 'assets/img/default-profile.png'

const Final = ({ data }) => {
  const Photo = data.get('photo') ? data.get('photo') : DefaultProfile
  return (
    <Panel header="Complete">
      <div className="text-center">
        <div className="picture-container">
          <div className="picture">
            <img src={Photo} alt="account_profile" className="picture-src" />
          </div>
          <h6>{data.get('username')}</h6>
          <kbd>{data.get('id')}</kbd>
          <h4>{data.get('full_name')}</h4>
        </div>
        <h5><em>The student password is sent to <strong>{data.get('email')}</strong></em></h5>
      </div>
    </Panel>
  )
}

Final.propTypes = {
  data: PropTypes.object,
}

export default Final



// WEBPACK FOOTER //
// ./src/containers/Admission/final.js